"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogTableDataProvider = exports.useAuditLogTableDataContext = void 0;
const React = __importStar(require("react"));
const AuditLogPageDataProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageDataProvider");
const AuditLogPageModelProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageModelProvider");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const AuditLogJSONModel_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogJSONModel");
const ProjectParticipantsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectParticipantsDataProvider");
const AuditLogTableDataContext = React.createContext(undefined);
const useAuditLogTableDataContext = () => {
    const context = React.useContext(AuditLogTableDataContext);
    if (!context) {
        throw new Error("useAuditLogTableDataContext must be used within a AuditLogTableDataContext.Provider");
    }
    return context;
};
exports.useAuditLogTableDataContext = useAuditLogTableDataContext;
const AuditLogTableDataProvider = (props) => {
    var _a, _b;
    const pageDataContext = (0, AuditLogPageDataProvider_1.useAuditLogPageDataContext)();
    const pageModelContext = (0, AuditLogPageModelProvider_1.useAuditLogPageModelContext)();
    const projectParticipantsDataContext = (0, ProjectParticipantsDataProvider_1.useProjectParticipantsDataContext)();
    const feature = pageDataContext.state;
    const urlJSONModel = pageDataContext.stateFns.getURLJSONModel();
    const formJSONModel = pageModelContext.pageModelStateFns.getFormJSONModel();
    const data = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        var _a, _b;
        const projectParticipantsMapped = lodash_1.default.mapKeys((_a = projectParticipantsDataContext.participants.data) === null || _a === void 0 ? void 0 : _a.participantViews, v => v.principal.toText());
        return lodash_1.default.map((_b = feature.data) === null || _b === void 0 ? void 0 : _b.auditLogRecords, v => {
            var _a;
            return {
                record: v,
                participantName: (_a = projectParticipantsMapped[v.principal]) === null || _a === void 0 ? void 0 : _a.name
            };
        });
    }, [(_a = feature.data) === null || _a === void 0 ? void 0 : _a.auditLogRecords, (_b = projectParticipantsDataContext.participants.data) === null || _b === void 0 ? void 0 : _b.participantViews], lodash_1.default.isEqual);
    const tableStatus = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return calculateTableStatus(formJSONModel.serialize(), urlJSONModel.serialize());
    }, [formJSONModel.serialize(), urlJSONModel.serialize()], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        data, tableStatus,
    }), [data, tableStatus,], lodash_1.default.isEqual);
    return React.createElement(AuditLogTableDataContext.Provider, { value: value }, props.children);
};
exports.AuditLogTableDataProvider = AuditLogTableDataProvider;
const calculateTableStatus = (formModel, urlModel) => {
    formModel = AuditLogJSONModel_1.AuditLogJSONModel.makeModelStateCleanForTableStatusCheck(formModel);
    urlModel = AuditLogJSONModel_1.AuditLogJSONModel.makeModelStateCleanForTableStatusCheck(urlModel);
    const formModelEqualsToURLModel = lodash_1.default.isEqual(formModel, urlModel);
    if (formModelEqualsToURLModel) {
        return "loaded";
    }
    return "parametersChanged";
};
